import { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

interface Content extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  children: ReactNode;
}

export function Content({ children, className, ...rest }: Content) {
  return (
    <div className={`px-4 py-6 border-t ${className || ''}`} {...rest}>
      {children}
    </div>
  );
}
